
import React from 'react';
import { AppSidebar } from './AppSidebar';
import { AppTopbar } from './AppTopbar';
import { MobileBottomBar } from './MobileBottomBar';
import { MobileTopbar } from './MobileTopbar';
import { cn } from '@/lib/utils';
import { SidebarProvider } from "@/components/ui/sidebar";
import { useIsMobile } from '@/hooks/use-mobile';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-background text-foreground">
        <AppSidebar />
        <div className="flex flex-col flex-1 overflow-hidden">
          {isMobile ? <MobileTopbar /> : <AppTopbar />}
          <main className={cn(
            "flex-1 overflow-auto scrollbar-thin scrollbar-thumb-border/40 scrollbar-track-transparent hover:scrollbar-thumb-border/60",
            isMobile ? "pb-36 safe-area-bottom" : "p-6", // Increased bottom padding on mobile for the navigation bar
            isMobile && "pt-0" // Remove top padding on mobile as the header already has safe area padding
          )}>
            <div className={isMobile ? "p-3" : ""}>
              {children}
            </div>
          </main>
          {isMobile && <MobileBottomBar />}
        </div>
      </div>
    </SidebarProvider>
  );
};
